module.exports = __webpack_public_path__ + "static/media/orange.b3778637.svg";